import React from "react";
import client from "@culturehq/client";
import { Button, Modal, Success } from "@culturehq/components";

import { useTryCatch } from "app/hooks";
import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModal from "components/common/ChqModal";

const RecognitionExport = () => {
  const [{ error, success, trying }, onClick] = useTryCatch(() => client.exportRecognitions());

  return (
    <ChqModal
      trigger={onTrigger => (
        <div className="pull-right padding-right-15px">
          <Button inverted icon="ios-download-outline" onClick={onTrigger}>
            <Trans>Export Recognitions</Trans>
          </Button>
        </div>
      )}
    >
      <Modal.Heading>
        <Trans>Export Recognitions</Trans>
      </Modal.Heading>
      <Modal.Body>
        <p>
          <Trans>
            Would you like to export all your recognitions? Once the list has
            been processed, an e-mail will be sent to you with your data in a
            .csv file.
          </Trans>
        </p>

        {!success && (
          <Button primary onClick={onClick}>
            {
              trying
                ? <Trans>Requesting...</Trans>
                : <Trans>Export Recognitions</Trans>
            }
          </Button>
        )}

        {error && <ErrorMessage error={error} />}
        {success && (
          <Success>Request received. An e-mail will be sent to you soon.</Success>
        )}
      </Modal.Body>
    </ChqModal>
  );
};

export default RecognitionExport;
